import axios from '../axios'
import appConfig from 'app.config'
import { getHeadersWithJwtToken } from 'auth/utils/auth-util'
import { logError } from 'shared/AppInsight'

export interface DecreaseLimitParams {
	desiredLimit: number
	ssn: string
	email: string
	mobileNumber: string
	partyId: string
}

export type LimitChangeDesicion =
	| 'Approved'
	| 'Investigation'
	| 'Rejected'
	| 'Invalid'
	| 'Error'

export interface DecreaseLimitResponse {
	approvedCreditLimit: number
	decision: LimitChangeDesicion
	rejectionReason: {
		code: string | null
		message: string | null
	}
	effectiveInterestRate: number
	esigningApplicantUrl: string | null
	onlineIdentification: string | null
	applicationId: number
}

export async function decreaseLimit(params: DecreaseLimitParams) {
	return axios
		.post<DecreaseLimitResponse>(
			`${appConfig.customerDataBaseUrl}/api/limit/decrease`,
			params,
			await getHeadersWithJwtToken(),
		)
		.then(({ data }) => data)
		.catch((err) => {
			logError(err)
			throw err
		})
}
